// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import { DEFAULT_REDUCER_KEY } from '@tcp/core/src/utils/cache.util';
import constants from './StoreDetail.constants';

export const initialState = fromJS({
  [DEFAULT_REDUCER_KEY]: null,
  suggestedStores: [],
  defaultStore: null,
  geoDefaultStore: null,
  storesSummaryListUS: [],
  storesSummaryListCA: [],
  storesSummaryListOthers: [],
  bopisStoresOnCart: [],
  bopisItemInventory: [],
  storelocator_Promo1: '',
  storelocator_Promo2: '',
  storelocator_Promo3: '',
  isStoreDetailLoading: false,
});

const StoreDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_CURRENT_STORE:
      return state.set('currentStore', action.payload);
    case constants.SET_SUGGESTED_STORE:
      return state.set('suggestedStores', action.payload?.nearByStores);
    case constants.SET_MODULEX_CONTENT:
      return state.set(action.payload.key, action.payload.value);
    case constants.SET_LOADING_STORE_DETAIL_STATUS:
      return state.set('isStoreDetailLoading', action.payload);
    case constants.SET_SUGGESTED_STORE_LOADING:
      return state.set('isNearbyStoresLoading', action.payload);
    case constants.FETCH_PRODUCTS_REQUEST:
      return state.set('caraosalDataloading', true).set('error', null);
    case constants.FETCH_PRODUCTS_SUCCESS:
      return state.set('caraosalDataloading', false).set('storeSpecialProducts', action.data);
    case constants.FETCH_PRODUCTS_FAILURE:
      return state.set('caraosalDataloading', false).set('error', action.error);
    case constants.RESET_STORE_SPECIAL_PRODUCTS:
      return state.set('storeSpecialProducts', action.payload);
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default StoreDetailReducer;
